import { xMinMaxValues } from 'ml-spectra-processing';
import { getFactorNumber } from './getFactorNumber';
export function getBestFactor(array, options = {}) {
    const { maxValue, factor, minMax } = options;
    if (factor !== undefined) {
        return factor;
    }
    // is there non integer number ?
    let onlyInteger = true;
    for (let y of array) {
        if (Math.round(y) !== y) {
            onlyInteger = false;
            break;
        }
    }
    if (onlyInteger) {
        return 1;
    }
    // we need to rescale the values
    // need to find the max and min values
    const extremeValues = minMax || xMinMaxValues(array);
    return getFactorNumber(extremeValues, maxValue);
}
//# sourceMappingURL=getBestFactor.js.map